import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-6xl font-bold text-gray-300">404</h1>
      <p className="text-lg text-gray-500">Pagina nu a fost găsită</p>
      <Link to="/">
        <Button>Înapoi la pagina principală</Button>
      </Link>
    </div>
  );
}
